<template>
    <v-container>
        <v-flex>
            <div class="text-xs-center">
                <h1 class="story-title" :style="{fontSize: storyTitleSize, letterSpacing: storyTitleLetterSpacing}">{{ $store.state.story.title }}</h1>

                <div class="author-name subheading mb-3">By {{ $store.state.author.pen_name || $store.state.author.name }}</div>
            </div>

            <v-card v-if="section" :class="`shadow ${readerPadding}`">
                <v-card-title>
                    <v-flex>
                        <v-layout row>
                            <v-flex shrink :class="{invisible: isFirstPage}">
                                <v-btn flat icon small class="ma-0" @click="goToPreviousChapter">
                                    <v-icon class="grey--text">fal fa-chevron-left</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex>
                                <h2 class="headline text-xs-center">
                                    <span v-if="section.title">{{ section.title }}</span>
                                    <span v-else>Chapter {{ $route.params.section_number }}</span>
                                </h2>
                            </v-flex>
                            <v-flex shrink :class="{invisible: isLastPage}">
                                <v-btn flat icon small class="ma-0" @click="goToNextChapter">
                                    <v-icon class="grey--text">fal fa-chevron-right</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="chapter-content" v-if="sectionHasContent" ref="chapterContent">
                    <div v-for="(scene, i) in section.scenes" :key="scene.id" class="scene">
                        <div v-html="$sanitize(scene.content)"></div>
                    </div>
                </v-card-text>

                <v-card-text v-else class="grey--text text-xs-center py-5 my-5">[No content]</v-card-text>

                <v-card-title>
                    <v-flex shrink :class="{invisible: isFirstPage}">
                        <v-btn flat icon small class="ma-0" @click="goToPreviousChapter">
                            <v-icon class="grey--text">fal fa-chevron-left</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex grow>
                        <p class="text-xs-center">
                            {{ $route.params.section_number }} / {{ $store.state.preview.snapshot.length }}
                        </p>
                    </v-flex>
                    <v-flex shrink :class="{invisible: isLastPage}">
                        <v-btn flat icon small class="ma-0" @click="goToNextChapter">
                            <v-icon class="grey--text">fal fa-chevron-right</v-icon>
                        </v-btn>
                    </v-flex>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="pb-0">
                    <plot-factory-branding></plot-factory-branding>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-container>
</template>

<script>
export default {
    methods: {
        goToPreviousChapter() {
            if (!this.isFirstPage) {
                this.$router.push(`/${parseInt(this.$route.params.section_number) - 1}`)
            }
        },

        goToNextChapter() {
            if (!this.isLastPage) {
                this.$router.push(`/${parseInt(this.$route.params.section_number) + 1}`)
            }
        },
    },

    mounted() {
        let ctrlDown = false
        const CTRL_KEY = 17
        const CMD_KEY = 91
        const C_KEY = 67

        window.document.addEventListener('keydown', (e) => {
            if (e.keyCode === CTRL_KEY || e.keyCode === CMD_KEY) {
                ctrlDown = true
            }
        })

        window.document.addEventListener('keyup', (e) => {
            if (e.keyCode === CTRL_KEY || e.keyCode === CMD_KEY) {
                ctrlDown = false
            }
        })

        if (this.$refs.chapterContent) {
            this.$refs.chapterContent.addEventListener('keydown', (e) => {
                if (ctrlDown && e.keyCode === C_KEY) {
                    return false
                }
            })
        }

        window.document.addEventListener('keydown', (e) => {
            if (ctrlDown && (e.keyCode === C_KEY)) {
                e.preventDefault()
            }
        })

        // des
        if (this.$refs.chapterContent) {
            this.$refs.chapterContent.addEventListener('contextmenu', (e) => {
                e.preventDefault()

                return false
            }, false);
        }
    },

    computed: {
        section() {
            return this.$store.state.preview.snapshot[parseInt(this.$route.params.section_number - 1)]
        },

        sectionHasContent() {
            let length = 0

            this.section.scenes.forEach((scene) => {
                length += (scene.content || '').length
            })

            return length > 0
        },

        isFirstPage() {
            return parseInt(this.$route.params.section_number) === 1
        },

        isLastPage() {
            return parseInt(this.$route.params.section_number) === this.$store.state.preview.snapshot.length
        },

        readerPadding() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return ''
                case 'sm':
                    return 'pa-3'
                case 'md':
                    return 'pa-3'
                case 'lg':
                    return 'pa-3'
                case 'xl':
                    return 'pa-3'
            }
        },

        storyTitleSize() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return '26px'
                case 'sm':
                    return '40px'
                case 'md':
                    return '40px'
                case 'lg':
                    return '40px'
                case 'xl':
                    return '40px'
            }
        },

        storyTitleLetterSpacing() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return '0'
                case 'sm':
                    return '2px'
                case 'md':
                    return '2.5px'
                case 'lg':
                    return '2.5px'
                case 'xl':
                    return '2.5px'
            }
        },
    },
}
</script>

<style lang="scss">
.story-title {
    font-weight: 300;
    letter-spacing: 2.5px;
    color: rgba(#000, .65);
}

.author-name {
    color: rgba(#000, .5);
}

.chapter-content {
    font-family: 'Lora', 'Georgia', 'Times New Roman', serif;
    font-size: 16px;
    user-select: none;
}

.invisible {
    visibility: hidden;
}

.scene:not(:last-of-type):after {
    text-align: center;
    content: '* * *';
    display: block;
    padding: 2rem 0;
}
</style>
